<mnt-loading-state color="primary" [label]="text"></mnt-loading-state>